import { Clear, Search } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  useTheme,
} from "@mui/material";

interface SearchBarProps extends Omit<TextFieldProps, "onSubmit"> {
  handleSubmit: (event: React.FormEvent) => void;
  handleClear: () => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  handleSubmit,
  handleClear,
  placeholder,
  sx,
  ...textFieldProps
}) => {
  const theme = useTheme();

  return (
    <TextField
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClear}
              size="small"
              sx={{
                color: theme.colors.secondary[5],
                width: 32,
                height: 32,
                borderRadius: "6px",
              }}
            >
              <Clear fontSize="small" />
            </IconButton>
            <IconButton
              onClick={handleSubmit}
              sx={{
                width: 32,
                height: 32,
                borderRadius: "6px",
                color: theme.palette.primary.main,
                ml: 1,
                backgroundColor: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
            >
              <Search
                fontSize="small"
                sx={{ color: theme.palette.primary.contrastText }}
              />
            </IconButton>
          </InputAdornment>
        ),
        ...textFieldProps.InputProps,
      }}
      fullWidth
      placeholder={placeholder ?? "Search..."}
      size="small"
      sx={{
        maxWidth: 360,
        justifyContent: "center",
        height: "42px",
        borderRadius: "8px",
        fontSize: "8px",
        bgcolor: theme.colors.grey,
        "& .MuiOutlinedInput-root": {
          pr: "4px",
          fontSize: { sm: "16px", md: "12px" },
          "& fieldset": {
            border: "none",
          },
          "& input::placeholder": {
            color: theme.colors.text[0],
            fontSize: 12,
            fontWeight: 500,
            opacity: 1,
          },
        },
        "& .MuiInputBase-root	": {
          height: "40px",
        },
        ...sx,
      }}
      variant="outlined"
      {...textFieldProps}
    />
  );
};
